import React from "react";
import { Redirect } from "react-router-dom";
import api from "../../components/api";

// import { Container } from './styles';

export default function Dashboard() {
    return <Redirect to="/orders" />;
}
